import { useEffect } from "react";

/**
 * IubendaInit
 * Inietta gli script di Iubenda per:
 * - Banner cookie (cs.iubenda.com)
 * - Widget Privacy Policy e Cookie Policy (cdn.iubenda.com/iubenda.js)
 *
 * Il banner e il consenso vengono gestiti interamente da Iubenda.
 */
export default function CookieConsent() {
    useEffect(() => {
        // Configura il Cookie Solution di Iubenda
        window._iub = window._iub || [];
        window._iub.csConfiguration = {
            perPurposeConsent: true,
            siteId: 568964,
            whitelabel: false,
            cookiePolicyId: 7870512,
            banner: {
                acceptButtonDisplay: true,
                closeButtonRejects: true,
                customizeButtonDisplay: true,
                explicitWithdrawal: true,
                listPurposes: true,
                rejectButtonDisplay: true,
            },
        };
        window._iub.csLangConfiguration = {
            it: { cookiePolicyId: 7870512 },
        };

        // Carica lo script di sincronizzazione Iubenda
        const syncScript = document.createElement("script");
        syncScript.type = "text/javascript";
        syncScript.src = "//cs.iubenda.com/sync/568964.js";
        document.head.appendChild(syncScript);

        // Carica lo script principale del Cookie Solution
        const csScript = document.createElement("script");
        csScript.type = "text/javascript";
        csScript.src = "//cdn.iubenda.com/cs/iubenda_cs.js";
        csScript.charset = "UTF-8";
        csScript.async = true;
        document.head.appendChild(csScript);

        return () => {
            // Cleanup (opzionale — normalmente gli script Iubenda non vengono rimossi)
            try {
                document.head.removeChild(syncScript);
                document.head.removeChild(csScript);
            } catch (_) { }
        };
    }, []);

    // Nessun markup: il banner è renderizzato direttamente da Iubenda
    return null;
}
